import { fetchWithAuth, ApiError } from './client';

async function request(path = '', body) {
  const data = await fetchWithAuth(`/json/social-shares${path}`, {
    method: body ? 'POST' : 'GET',
    ...(body ? { body } : {}),
    timeoutMs: path === '/verify' ? 65000 : 30000,
    networkRetries: 0,
  });
  if (data.error) throw new ApiError(data.message || 'Unable to load sharing rewards.', data.status || 400, data);
  return data;
}
export const socialSharesApi = {
  list: () => request(),
  start: platform => request('/start', { platform }),
  suggestions: (generic = false) => request('/suggestions', { generic }),
  verify: (platform, postUrl) => request('/verify', { platform, postUrl }),
};
